/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsExportFragmentsQueryResponse, FragmentsExportFragmentsPathParams, FragmentsExportFragmentsQueryParams, FragmentsExportFragments401, FragmentsExportFragments403 } from "../models/FragmentsExportFragments";

export function getFragmentsExportFragmentsUrl(station: FragmentsExportFragmentsPathParams["station"]) {
  const res = { method: 'GET', url: `/fragments/v1/export/${station}` as const }
  return res
}

/**
 * @summary Export fragments of a station
 * {@link /fragments/v1/export/:station}
 */
export async function fragmentsExportFragments(station: FragmentsExportFragmentsPathParams["station"], params: FragmentsExportFragmentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FragmentsExportFragmentsQueryResponse, ResponseErrorConfig<FragmentsExportFragments401 | FragmentsExportFragments403>, unknown>({ method : "GET", url : getFragmentsExportFragmentsUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}